import { createSlice } from '@reduxjs/toolkit';
import {ResponseApi} from "../BaseApi";
import { postSessionStorageLoader } from '../../Apis/functions';

const DevicesSlice = createSlice({
    name: 'devices',
    initialState: {
        getListStatusDevice: [],
        getAllDevices: [],
        getAllDevicesZoneNull: [],
        updateDeviceApi: null,
        updateAirbnk: null,
        getAntiPassBackType: [],
        getEscortMode: [],
        getAuthentication: [],
        deleteAirbnk: null,
        deleteSmartLock: null,
        removeDevicesZone: null,
        addFreeDevice: null,
        getDeviceAirbnkLock: [],
        getDeviceDetails: [],
        getDeviceLog: [],
        getQrCode: null,
        getDeviceLogPageable: [],
        createAirbnkLock: null,
        createDeviceApi: null,
        getAllDevicesByModeIds:[]
    },
    extraReducers: {
        'devices/getListStatusDevice/fulfilled': (state, action) => {
            state.getListStatusDevice = ResponseApi(action.payload);
        },
        'devices/getAntiPassBackType/fulfilled': (state, action) => {
            state.getAntiPassBackType = ResponseApi(action.payload);
        },
        'devices/getEscortMode/fulfilled': (state, action) => {
            state.getEscortMode = ResponseApi(action.payload);
        },
        'devices/getAuthentication/fulfilled': (state, action) => {
            state.getAuthentication = ResponseApi(action.payload);
        },
        'devices/getAllDevices/fulfilled': (state, action) => {
            state.getAllDevices = ResponseApi(action.payload);
        },
        'devices/getAllDevicesZoneNull/fulfilled': (state, action) => {
            state.getAllDevicesZoneNull = ResponseApi(action.payload);
        },
        'devices/getDeviceAirbnkLock/fulfilled': (state, action) => {
            state.getDeviceAirbnkLock = ResponseApi(action.payload);
        },
        'devices/getDeviceDetails/fulfilled': (state, action) => {
            state.getDeviceDetails = ResponseApi(action.payload);
        },
        'devices/getDeviceLog/fulfilled': (state, action) => {
            state.getDeviceLog = ResponseApi(action.payload);
        },
        'devices/getQrCode/fulfilled': (state, action) => {
            state.getQrCode = ResponseApi(action.payload);
        },
        'devices/getDeviceLogPageable/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getDeviceLogPageable = data?.data;
                postSessionStorageLoader(false);
            } else if (status >= 400 && status < 500) {
                postSessionStorageLoader(false);
            }
        },
        'devices/deleteAirbnk/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.deleteAirbnk = data;
            }
        },
        'devices/deleteSmartLock/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.deleteSmartLock = data;
            }
        },
        'devices/getAllDevicesByModeIds/fulfilled': (state, action) => {
            state.getAllDevicesByModeIds = ResponseApi(action.payload);
        },
    },
});

export const { ClearGetListZoneMap } = DevicesSlice.actions;

export default DevicesSlice.reducer;
